import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`

/**
 * [상품관리 > 상품등록] 전체 카테고리 목록 조회
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
const readAllCategoryList = async () => {
  const res = await axios.get(`${baseUrl}/admin/product-category/list`)
  return res
}

/**
 * 카테고리 목록 조회
 * @param param
 */
const readCategoryList = async (param) => {
  const res = await axios.get(
    `${baseUrl}/admin/product-category/list/category`,
    {
      params: param,
    },
  )
  return res
}

/**
 * [상품관리 > 브랜드 조회] 판매자 목록 조회
 * @param userId
 */
const readSellerList = async (userId) => {
  const res = await axios.get(`${baseUrl}/admin/product-seller/list`, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 브랜드 조회] 브랜드 목록 검색
 * @param param
 * @param userId
 */
const readBrandListForSearch = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product-brand/search`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 브랜드 조회] 브랜드 목록 검색
 * @param param
 * @param userId
 */
const readBrandList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product-brand/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 상품등록] 상품 영양소 목록 조회
 * @param userId
 */
const readNutrientList = async (userId) => {
  const res = await axios.get(`${baseUrl}/admin/product-nutrient/list`, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 상품등록] 상품 영양소 목록 조회
 * @param userId
 */
const readNutrientSearchOption = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product-nutrient/search`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 상품 조회/수정] 상품 상태별 갯수 조회
 * @param userId
 */
const readProductCntByStatus = async (userId) => {
  const res = await axios.get(`${baseUrl}/admin/product/status`, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 상품 조회/수정] 상품 목록 검색
 * @param param
 * @param userId
 */
const readProductList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [상품관리 > 상품 조회/수정] 상품 목록 검색
 * @param param
 * @param userId
 */
const readProductListAll = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product/list/all`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [판매관리 > 전화주문] 상품아이디별 옵션 목록 조회
 * @param param
 * @param userId
 */
const readProductOptionList = async (param, userId) => {
  const res = await axios.get(
    `${baseUrl}/admin/product/option/list/not-include`,
    {
      params: param,
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * [쿠폰 > 쿠폰 등록] 아이디 목록에 포함하지 않는 브랜드 목록 조회
 * @param param
 * @param userId
 */
const readBrandListNotIncluded = async (param, userId) => {
  const res = await axios.get(
    `${baseUrl}/admin/product-brand/list/not-include`,
    {
      params: param,
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * [쿠폰 > 쿠폰 등록] 아이디 목록에 포함하지 않는 상품 목록 조회
 * @param param
 * @param userId
 */
const readProductListNotIncluded = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product/list/not-include`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const readProduct = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/admin/product/one`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const createBrandListWithExcel = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/admin/product-brand/create`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const createProduct = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/admin/product/create`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const editProduct = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/admin/product/edit`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const invalidateProduct = async (productId, userId) => {
  const res = await axios.post(
    `${baseUrl}/v2/admin/products/${productId}/cdn-invalidation`,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

const v2CreateProduct = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/v2/admin/product/create`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const v2EditProduct = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/v2/admin/product/edit`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const readProductProgram = async (param) => {
  const res = await axios.get(`${baseUrl}/v2/admin/product-program`, {
    params: param,
  })
  return res
}

/**
 *
 * @param {*} productSetOptionId
 * @returns
 */
const readProductSetOption = async (param) => {
  const res = await axios.get(`${baseUrl}/v2/admin/product-set`, {
    params: param,
  })
  return res
}

const getProductTag = async (productId) => {
  const res = await axios.get(`${baseUrl}/admin/product/tags/${productId}`)
  return res
}

const createProductTag = async (param) => {
  const res = await axios.post(`${baseUrl}/admin/product/tags`, param)
  return res
}

const editProductTag = async (param) => {
  const res = await axios.put(`${baseUrl}/admin/product/tags`, param)
  return res
}

const deleteProductTag = async (tagId) => {
  const res = await axios.delete(`${baseUrl}/admin/product/tags/${tagId}`)
  return res
}

const productApi = {
  readAllCategoryList,
  readCategoryList,
  readSellerList,
  readBrandListForSearch,
  readBrandList,
  readNutrientList,
  readNutrientSearchOption,

  readProductCntByStatus,
  readProductList,
  readProductListAll,
  readProductOptionList,
  readBrandListNotIncluded,
  readProductListNotIncluded,
  readProduct,

  createBrandListWithExcel,
  createProduct,
  editProduct,

  invalidateProduct,
  v2CreateProduct,
  v2EditProduct,
  readProductProgram,
  readProductSetOption,
  getProductTag,
  createProductTag,
  editProductTag,
  deleteProductTag,
}

export default productApi
